import { useGeneratedGetPricingRecommendationsQuery } from '@/experiences/sales-portal/domain/pricing-agent/blocs/documents/get-pricing-recommendations.generated';
import { useMemo } from 'react';

interface UsePricingRecommendationsLoaderParams {
  taskTypeUUID: string;
}

export const usePricingRecommendationsLoader = ({
  taskTypeUUID,
}: UsePricingRecommendationsLoaderParams) => {
  const { data, error, loading, refetch } =
    useGeneratedGetPricingRecommendationsQuery({
      notifyOnNetworkStatusChange: true,
      variables: { taskTypeUUID },
    });

  return useMemo(
    () => ({
      data,
      error,
      loading,
      refetch,
    }),
    [data, error, loading, refetch],
  );
};
